export const en = {
  "header": {
    "brand": "CikaStudio",
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "nav": {
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "actions": {
    "copy": "Copy",
    "download": "Download",
    "clear": "Clear",
    "copied": "Copied!",
    "copyAll": "Copy All",
    "downloadTxt": "Download TXT",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "format": "Format",
    "minify": "Minify",
    "validate": "Validate",
    "convert": "Convert"
  },
  "footer": {
    "privacy": "Privacy",
    "terms": "Terms",
    "email": "Contact",
    "moreTools": "More Tools",
    "copyright": "© {year} CikaStudio. All rights reserved."
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark"
  },
  "common": {
    "clientSide": "100% client-side",
    "noUpload": "No data upload",
    "noAccount": "No account required",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success"
  },
  "randomNumber": {
    "title": "Random Number Generator",
    "subtitle": "Generate random numbers. Integer, decimal, hex, binary. ",
    "privacy": "100% client-side",
    "type": "Type",
    "integer": "Integer",
    "decimal": "Decimal",
    "hex": "Hex",
    "binary": "Binary",
    "min": "Min",
    "max": "Max",
    "count": "Count",
    "maxCount": "max 10,000",
    "settings": "Settings",
    "unique": "Unique values only",
    "sort": "Sort",
    "none": "None",
    "asc": "Ascending",
    "desc": "Descending",
    "generate": "Generate",
    "invalid": "Please enter valid numbers. Max must be ≥ min, count must be 1-10,000.",
    "results": "Results",
    "sum": "Sum",
    "avg": "Avg",
    "minResult": "Min",
    "maxResult": "Max",
    "history": "History"
  },
  "content": {
    "privacy": {
      "title": "Privacy & Security",
      "description": "🔒 All random number generation happens locally in your browser using the Web Crypto API. Your settings and results are never transmitted."
    },
    "guide": {
      "title": "How to Use Random Number Generator",
      "description": "Generate random integers, decimals, hex, and binary numbers instantly.",
      "steps": [
        {
          "title": "Choose number type",
          "description": "Select between integer, decimal, hexadecimal, or binary output formats depending on your use case."
        },
        {
          "title": "Set range and quantity",
          "description": "Define the minimum and maximum values, and choose how many numbers to generate in one batch."
        },
        {
          "title": "Copy your results",
          "description": "Click copy to save individual numbers or the entire batch to your clipboard. Download as a text file for larger sets."
        }
      ]
    },
    "features": {
      "title": "Key Features",
      "items": [
        "Multiple output formats: integer, decimal, hex, binary",
        "Cryptographically secure randomness via Web Crypto API",
        "Customizable min/max range for any use case",
        "Batch generation up to thousands of numbers",
        "One-click copy and download as text file",
        "100% client-side processing — zero data upload"
      ]
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "items": [
        {
          "question": "Is my data sent to a server?",
          "answer": "No. All random numbers are generated locally using your browser Web Crypto API. Nothing is transmitted or stored externally."
        },
        {
          "question": "Are the numbers truly random?",
          "answer": "Yes. The Web Crypto API provides cryptographically secure randomness suitable for security tokens, simulations, and statistical sampling."
        },
        {
          "question": "What is the maximum batch size?",
          "answer": "You can generate up to 10,000 numbers in a single batch. Larger sets may be limited by browser memory but can be generated in multiple batches."
        }
      ]
    },
    "related": {
      "title": "Related Tools",
      "tools": [
        {
          "name": "UUID Generator",
          "url": "/generator/uuid-generator",
          "description": "Generate universally unique identifiers for APIs and databases."
        },
        {
          "name": "Password Generator",
          "url": "/generator/password-generator",
          "description": "Generate strong, secure passwords and memorable passphrases."
        },
        {
          "name": "Hash Generator",
          "url": "/utility/hash-generator",
          "description": "Generate MD5, SHA-256, and other cryptographic hashes."
        }
      ]
    }
  }
};
